import { IconWrapper } from '../runtime';
export default IconWrapper('approval', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.99609 14.25H14M4.99986 4.13074C4.99986 2.40168 6.343 1 7.99986 1C9.65671 1 10.9999 2.40168 10.9999 4.13074C10.9999 5 10.0714 6.25 9.99986 6.5C9.80467 7.18202 9.87486 7.25 9.87486 7.75H13C13.5523 7.75 14 8.19772 14 8.75V10.25C14 10.8023 13.5523 11.25 13 11.25H3C2.44772 11.25 2 10.8023 2 10.25V8.75C2 8.19772 2.44772 7.75 3 7.75H6.12486C6.12486 7.25 6.19505 7.18202 5.99986 6.5C5.92831 6.25 4.99986 5 4.99986 4.13074Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});